import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./PortfolioSidebar.css";
import { getVisibleProjects } from "../data/portfolioProjects";
import { getTagStyle } from "../utils/tagColors";

export default function PortfolioSidebar() {
  const location = useLocation();
  const projects = getVisibleProjects();
  const [hasHoveredActive, setHasHoveredActive] = useState(false);

  // Reset the hover state when location changes (new page loaded)
  useEffect(() => {
    setHasHoveredActive(false);
  }, [location.pathname]);	return (
		<aside className="PortfolioSidebar">
			<nav className="PortfolioSidebar__nav">
				{projects.map((project) => {
					const isActive = location.pathname === project.path;
					return (
						<Link
							key={project.id}
							to={project.path}
							className={`PortfolioSidebar__item ${isActive ? 'PortfolioSidebar__item--active' : ''} ${isActive && !hasHoveredActive ? 'PortfolioSidebar__item--noTransition' : ''}`}
							style={{
								'--bg-gradient': project.bgImage
									? `linear-gradient(135deg, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.8) 50%, rgba(0,0,0,0.1) 100%), url(${project.bgImage})`
									: 'linear-gradient(135deg, rgba(0,0,0,1), rgba(255,255,255,0.25))'
							}}
							onMouseEnter={() => !isActive && setHasHoveredActive(true)}
						>
							<div className="PortfolioSidebar__itemContent">
								<span className="PortfolioSidebar__itemName">{project.name}</span>
								{project.tags && project.tags.length > 0 && (
									<div className="PortfolioSidebar__itemTags">
										{project.tags.map((tag, i) => (
											<span
												key={i}
												className="PortfolioSidebar__tag"
												style={getTagStyle(tag)}
											>
												{tag}
											</span>
										))}
									</div>
								)}
							</div>
						</Link>
					);
				})}
			</nav>
		</aside>
	);
}
